<template>
  <AppModalEdit
    v-model="modal"
    :loading="loading"
    @cancel="cancel"
    @clickExec="saveAuthChain(agencyAuthChain.id)"
  >
    <v-card v-if="agencyAuthChain !== null" flat>
      <v-card-title v-if="account !== null">
        <span class="headline">
          {{ account.name }} の
          <v-select
            :items="agencyList"
            :value="agencyAuthChain.id"
            :hide-details="true"
            @change="onAgencyChange"
            class="selectAgency"
            item-text="name"
            item-value="id"
            label="代理店を選択してください"
            solo
          />
          に対する権限を編集
        </span>
      </v-card-title>
      <div class="editAuthWrapper">
        <div class="inline-block name">
          <v-card-text>
            代理店: {{ agencyAuthChain.name }}に対しては
          </v-card-text>
        </div>
        <div class="inline-block selectbox">
          <v-select
            :items="items"
            :value="agencyAuthChain.getPermission()"
            :hide-details="true"
            @change="onParentPermissionChange"
            item-text="description"
            item-value="name"
            label="選択してください"
            solo
          />
        </div>
        <v-card
          v-for="adv in agencyAuthChain.advertiserAuths"
          :key="adv.id"
          color="blue lighten-5"
          class="margin2"
        >
          <div class="inline-block name">
            <v-card-text> 広告主: {{ adv.name }}に対しては </v-card-text>
          </div>
          <div class="inline-block selectbox">
            <v-select
              :items="items"
              :background-color="isColored(adv)"
              :value="adv.getPermission()"
              :hide-details="true"
              @change="onChildPermissionChange($event, adv.id)"
              label="選択してください"
              item-text="description"
              item-value="name"
              solo
            />
          </div>
          <div class="inline-block">
            <v-btn @click="setAllChildInherited(adv.id)"
              >案件権限リセット</v-btn
            >
          </div>
          <v-card
            v-for="io in adv.insertionOrderAuths"
            :key="io.id"
            color="blue lighten-4"
            class="margin2"
          >
            <div class="inline-block name">
              <v-card-text>案件: {{ io.name }}に対しては</v-card-text>
            </div>
            <div class="inline-block selectbox">
              <v-select
                :items="items"
                :background-color="isColored(io)"
                :value="io.getPermission()"
                :hide-details="true"
                @change="onGrandChildPermissionChange($event, io.id, adv.id)"
                label="選択してください"
                item-text="description"
                item-value="name"
                solo
              />
            </div>
          </v-card>
        </v-card>
      </div>
    </v-card>
  </AppModalEdit>
</template>

<script>
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
export default {
  name: 'EditAgencyAccountAuthModal',
  props: {
    dispatchGetAgencyAccountAuth: {
      type: Function,
      default: () => {},
    },
    agencyList: {
      type: Array,
      default: () => [],
    },
    agencyAuthChain: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [
        { name: 'none', description: '権限なし' },
        { name: 'readonly', description: 'レポート取得権限' },
        { name: 'operator', description: '運用権限' },
        { name: 'admin', description: '管理者権限' },
      ],
      account: null,
      modal: false,
      loading: false,
    }
  },
  methods: {
    open() {
      this.modal = true
    },
    close() {
      this.modal = false
    },
    prepare(account) {
      this.open()
      this.account = account
      // 現在編集中のアカウント情報を取得
      const accountId = this.account.id
      const agencyId = this.account.belongId
      const userType = this.account.userType
      // まず、その人が所属している代理店に対する権限を取得する
      this.dispatchGetAgencyAccountAuth({ agencyId, accountId, userType })
    },
    onAgencyChange(e) {
      // 現在編集中のアカウント情報を取得
      const accountId = this.account.id
      const agencyId = e
      const userType = this.account.userType
      // まず、その人が所属している代理店に対する権限を取得する
      this.dispatchGetAgencyAccountAuth({ agencyId, accountId, userType })
    },
    onParentPermissionChange(e) {
      this.$store.dispatch('agencyAccountAuth/ON_PARENT_PERMISSION_CHANGE', {
        permission: e,
      })
    },
    onChildPermissionChange(e, id) {
      this.$store.dispatch('agencyAccountAuth/ON_CHILD_PERMISSION_CHANGE', {
        id: id,
        permission: e,
      })
    },
    onGrandChildPermissionChange(e, id, parentId) {
      this.$store.dispatch(
        'agencyAccountAuth/ON_GRANDCHILD_PERMISSION_CHANGE',
        { id: id, permission: e, parentId: parentId },
      )
    },
    // TODO: 一旦これ
    isColored(io) {
      if (io.getInheritFlg() === true) {
        return 'transparent'
        // return 'grey lighten-2'
      } else {
        return ''
      }
    },
    cancel() {
      this.$store.dispatch('agencyAccountAuth/RESET')
    },
    setAllChildInherited(advId) {
      this.$store.dispatch('agencyAccountAuth/SET_ALL_INHERIT', { advId })
    },
    async saveAuthChain(agencyId) {
      this.loading = true
      const accountId = this.account.id
      try {
        await this.$store.dispatch('agencyAccountAuth/SAVE_AUTH_CHAIN', {
          agencyId,
          accountId,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
        this.loading = false
        this.$emit('save')
        this.close()
      } catch (e) {
        this.loading = false
        throw e
      }
    },
  },
}
</script>

<style scoped>
.margin2 {
  margin-left: 80px;
}

.selectAgency {
  display: inline-block;
  width: 250px;
}

.inline-block {
  display: inline-block;
}
.name {
  width: 300px;
}
.selectbox {
  width: 150px;
}

.editAuthWrapper {
  margin: 15px 0;
}
</style>
